var map = {
	"./logo_en_US.png": "MLzy",
	"./logo_zh_CN.png": "2wl+",
	"./logo_zh_HANT.png": "zBXc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CH2o";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile ^\.\/logo_.*\.png$
// module id = CH2o
// module chunks = 1